import { Component, computed, inject, input, type OnInit } from '@angular/core';
import { type HomebatteryAdviceFormRendering } from '@feh/homebattery-models';
import { HomebatteryAdviceFormComponent } from '@feh/homebattery-ui';
import { Store } from '@ngrx/store';
import {
  selectHomebatteryAdviceSubmitState,
  submitHomebatteryAdviceForm,
  setRedirectUrl,
} from '@feh/homebattery-store';
import { Router } from '@angular/router';
import { getAppConfig } from '@core/config-store';
import { AnalyticsUtils } from '@analytics/utils';
import { FehAddressCheckService } from '@innogy/feh/services';
import { TrackToolService } from '@analytics/events';
import * as Sentry from '@sentry/angular';

import {
  createForm,
  createTrackToolConfig,
  mapFormToSubmitPayload,
} from './homebattery-advice-form.helpers';

@Sentry.TraceClass({ name: 'FEIT-Homebattery-Advice-Container' })
@Component({
  selector: 'wl-homebattery-advice-form-container',
  templateUrl: './homebattery-advice-form.container.component.html',
  standalone: true,
  imports: [HomebatteryAdviceFormComponent],
  providers: [FehAddressCheckService],
})
export class HomebatteryAdviceFormContainerComponent implements OnInit {
  private readonly analyticsComponentName = 'thuisbatterij bti-flex lead';
  private readonly store = inject(Store);
  private readonly router = inject(Router);
  private readonly trackToolService = inject(TrackToolService);
  private readonly config = this.store.selectSignal(getAppConfig);
  private readonly e2eTrackingId =
    inject(AnalyticsUtils).generateAnalyticsE2EId();

  protected readonly form = computed(() =>
    createForm(this.rendering(), this.analyticsComponentName)
  );
  protected readonly trackToolConfig = computed(() =>
    createTrackToolConfig(
      this.analyticsComponentName,
      this.e2eTrackingId,
      this.form()
    )
  );
  protected readonly submitState = this.store.selectSignal(
    selectHomebatteryAdviceSubmitState
  );
  protected readonly addressCheckService = inject(FehAddressCheckService);

  public readonly rendering = input.required<HomebatteryAdviceFormRendering>();

  ngOnInit(): void {
    this.store.dispatch(
      setRedirectUrl({ redirectUrl: this.rendering().fields.ThankYouPageUrl })
    );
  }

  protected submit() {
    this.form().markAllAsTouched();

    if (this.form().valid) {
      this.trackToolService.completeTool(this.trackToolConfig());
      this.store.dispatch(
        submitHomebatteryAdviceForm({
          payload: mapFormToSubmitPayload(
            this.form(),
            this.rendering(),
            this.config()?.brand === 'ed' ? 'energiedirect' : 'essent',
            this.router.url,
            this.e2eTrackingId
          ),
        })
      );
    }
  }
}
